var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"4.75","y":"0.5","width":"11.7508","height":"11.7508","stroke":"white","key":0}),React.createElement("rect",{"x":"0.5","y":"4.14258","width":"11.7508","height":"11.7508","fill":"black","stroke":"white","key":1})]);
}

Copy.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
